import PropTypes from 'prop-types';

/**
 * A two-segment All/Any control for a keyword-cloud column's match mode.
 * All → mode 'and' (must have every value), Any → mode 'or' (has any).
 *
 * Extracted from FilterChipRail so the chip-rail badge and the keyword-cloud
 * editor share one control. Decoupled from any store action: it just reports the
 * chosen mode via `onSetMode(mode)`; the caller decides what to do with it.
 */
const PillModeToggle = ({ mode, onSetMode }) => {
  const isAny = mode === 'or';
  return (
    <span className="pill-mode-toggle">
      <button
        type="button"
        className={isAny ? '' : 'on'}
        aria-pressed={!isAny}
        onClick={() => onSetMode('and')}
      >
        All
      </button>
      <button
        type="button"
        className={isAny ? 'on' : ''}
        aria-pressed={isAny}
        onClick={() => onSetMode('or')}
      >
        Any
      </button>
    </span>
  );
};

PillModeToggle.propTypes = {
  mode: PropTypes.string,
  onSetMode: PropTypes.func.isRequired
};

export default PillModeToggle;
